/**
 * THE ASK ONE KEY - Ctrl+K on Windows and Linux, ⌘K on a Mac (David, 1 Nov
 * late). It replaced the old Ctrl-and-I key, which is gone everywhere.
 *
 * ON A MAC IT IS ⌘ ONLY. Ctrl+K there is the system's "delete to the end of
 * the line" inside any text field, so taking it would eat a person's typing.
 * Elsewhere it is Ctrl only (the Windows key is not a modifier a page sees).
 * Never with Shift or Alt, so Ctrl+Shift+K (Firefox's console) is untouched.
 *
 * It fires from text fields too: the hub has no rich-text editor, so Ctrl+K
 * means nothing inside one of its fields. The browser's own Ctrl+K (focus the
 * address bar to search) IS taken - the deliberate trade-off, see
 * lib/shop.ts isCommandKey. AppShell still stands down while a dialog traps
 * focus ([aria-modal="true"]), so AddStock's own Ctrl+K search keeps working.
 *
 * Pure, so the render suite (which has no DOM) can reach the half it can test.
 */

export type KeyLike = { key: string; ctrlKey: boolean; metaKey: boolean; shiftKey: boolean; altKey: boolean }

/** Detected ONCE per page load. No navigator (the render suite) = not a Mac. */
export function detectMac(nav: { platform?: string; userAgent?: string } | undefined =
  typeof navigator === 'undefined' ? undefined : navigator): boolean {
  if (!nav) return false
  const p = `${nav.platform ?? ''} ${nav.userAgent ?? ''}`
  return /Mac|iPhone|iPad|iPod/i.test(p)
}

export const IS_MAC = detectMac()

export function isAskOneKey(e: KeyLike, mac: boolean = IS_MAC): boolean {
  if (e.shiftKey || e.altKey) return false
  if (e.key.toLowerCase() !== 'k') return false
  return mac ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey
}

/** What the launcher shows, and what aria-keyshortcuts says. */
export function askOneKeyLabel(mac: boolean = IS_MAC): { kbd: string; aria: string } {
  return mac ? { kbd: '⌘ K', aria: 'Meta+K' } : { kbd: 'Ctrl K', aria: 'Control+K' }
}
